<template>
    <div class="sk-phone" aria-hidden="true">
        <header class="sk-topbar">
            <div class="sk-topbar-burger">
                <div
                    v-for="n in 3"
                    v-bind:key="n"
                    class="sk-topbar-burger-line"
                />
            </div>
            <div class="sk-topbar-brand" />
            <div class="sk-topbar-wallet">
                <div class="sk-topbar-wallet-amount" />
                <div class="sk-topbar-wallet-coin" />
            </div>
            <div class="sk-topbar-avatar" />
        </header>
        <div class="sk-subbar">
            <div class="sk-subbar-crumb" />
            <div class="sk-subbar-pill" />
        </div>
        <nav class="sk-tabs">
            <div
                v-for="n in 4"
                v-bind:key="n"
                class="sk-tabs-item"
            />
        </nav>
        <main class="sk-body">
            <section class="sk-card">
                <div class="sk-card-head">
                    <div class="sk-card-head-title" />
                    <div class="sk-card-head-badge" />
                    <div class="sk-card-head-meta" />
                </div>
                <SkeletonOddsBlock
                    v-for="(spotlight, oddsBlockIndex) in FIRST_LEAGUE_ODDS_BLOCKS"
                    v-bind:key="oddsBlockIndex"
                    v-bind:rowCount="FIRST_LEAGUE_ROW_COUNT"
                    v-bind:spotlight="spotlight"
                    v-on:spotlight="setSpotlightElement"
                />
                <div class="sk-card-tools">
                    <div class="sk-card-tools-icon" />
                    <div class="sk-card-tools-icon" />
                    <div class="sk-card-tools-icon" />
                    <div class="sk-card-tools-action" />
                </div>
                <div class="sk-card-rule" />
            </section>

            <section
                v-for="(oddsBlocks, otherLeagueIndex) in OTHER_LEAGUE_ODDS_BLOCKS"
                v-bind:key="otherLeagueIndex"
                class="sk-card _event"
            >
                <div class="sk-event-promo">
                    <div class="sk-event-promo-tag" />
                    <div class="sk-event-promo-text" />
                </div>
                <SkeletonOddsBlock
                    v-for="(spotlight, oddsBlockIndex) in oddsBlocks"
                    v-bind:key="oddsBlockIndex"
                    v-bind:rowCount="OTHER_LEAGUE_ROW_COUNT"
                    v-bind:spotlight="spotlight"
                    v-on:spotlight="setSpotlightElement"
                />
            </section>
        </main>
        <nav class="sk-nav">
            <div
                v-for="n in 4"
                v-bind:key="n"
                class="sk-nav-item"
            >
                <div class="sk-nav-item-icon" />
                <div class="sk-nav-item-label" />
            </div>
        </nav>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted } from 'vue';
    import SkeletonOddsBlock from '@/components/betSlipTutorial/SkeletonOddsBlock.vue';
    import { SingleModeBetSlipTutorialSpotlight } from '@/interface/enum';

    interface ISpotlightCell {
        name: SingleModeBetSlipTutorialSpotlight;
        element: HTMLElement | null;
    }

    const emit = defineEmits<{
        'update:spotlightCells': [ISpotlightCell[]];
    }>();

    const FIRST_LEAGUE_ROW_COUNT = 2;
    const OTHER_LEAGUE_ROW_COUNT = 1;

    const NO_SPOTLIGHTS = [null, null];

    const FIRST_LEAGUE_ODDS_BLOCKS = [
        { name: SingleModeBetSlipTutorialSpotlight.FirstLeagueOddsMock, groupIndex: 0, cell: 1 },
        null,
    ];

    const OTHER_LEAGUE_ODDS_BLOCKS = [
        [null, { name: SingleModeBetSlipTutorialSpotlight.OtherLeagueOddsMock, groupIndex: 1, cell: 1 }],
        NO_SPOTLIGHTS,
        NO_SPOTLIGHTS,
    ];

    const spotlightElements = new Map<SingleModeBetSlipTutorialSpotlight, HTMLElement | null>();

    function setSpotlightElement({ name, element }: ISpotlightCell) {
        spotlightElements.set(name, element);
    }

    function toSpotlightCell(name: SingleModeBetSlipTutorialSpotlight): ISpotlightCell {
        return { name, element: spotlightElements.get(name) ?? null };
    }

    onMounted(() => {
        emit('update:spotlightCells', Object.values(SingleModeBetSlipTutorialSpotlight).map(toSpotlightCell));
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/betSlipTutorial/sportLobbySkeleton";
</style>
